import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bedSelect"]

  connect() {
    this.updateAvailableBeds()
  }

  updateAvailableBeds() {
    const selectedBeds = new Set(
      Array.from(this.bedSelectTargets)
        .map(select => select.value)
        .filter(value => value !== "")
    )

    this.bedSelectTargets.forEach(select => {
      Array.from(select.options).forEach(option => {
        if (option.value === "") return // Skip prompt option
        
        const isCurrentlySelected = select.value === option.value
        option.disabled = selectedBeds.has(option.value) && !isCurrentlySelected
      })
    })
  }

  bedSelectTargetConnected(element) {
    element.addEventListener("change", () => this.updateAvailableBeds())
  }
}
